import {
  BookOpen,
  Bot,
  Brain,
  Briefcase,
  Bug,
  Calendar,
  Camera,
  ChartBar,
  Clock,
  Cloud,
  Code,
  Coffee,
  Compass,
  Cpu,
  Crown,
  Database,
  Feather,
  FileText,
  FlaskConical,
  Flame,
  Gem,
  Ghost,
  GitBranch,
  Github,
  Globe,
  Headphones,
  Laptop,
  Layers,
  Leaf,
  Lightbulb,
  Mail,
  MessageSquare,
  Package,
  Palette,
  PenTool,
  Rocket,
  Search,
  Server,
  Shield,
  Smartphone,
  Sparkles,
  SquareKanban,
  Telescope,
  Terminal,
  Wallet,
  Webhook,
  Workflow,
  Wrench,
  Zap,
  type LucideIcon,
} from "lucide-react";

/**
 * The avatar icons, keyed as core's `AVATAR_ICONS` (`lib/avatars.ts`) — the two
 * lists must hold the same keys, since core refuses a key it does not know and a
 * key missing here draws initials. In picker order.
 */
export const AVATAR_ICONS: Record<string, LucideIcon> = {
  bot: Bot,
  crown: Crown,
  sparkles: Sparkles,
  "square-kanban": SquareKanban,
  clock: Clock,
  server: Server,
  github: Github,
  "git-branch": GitBranch,
  brain: Brain,
  code: Code,
  terminal: Terminal,
  database: Database,
  cloud: Cloud,
  rocket: Rocket,
  wrench: Wrench,
  bug: Bug,
  shield: Shield,
  globe: Globe,
  mail: Mail,
  "message-square": MessageSquare,
  calendar: Calendar,
  "chart-bar": ChartBar,
  "file-text": FileText,
  "book-open": BookOpen,
  palette: Palette,
  "pen-tool": PenTool,
  camera: Camera,
  zap: Zap,
  flame: Flame,
  leaf: Leaf,
  cpu: Cpu,
  package: Package,
  search: Search,
  compass: Compass,
  "flask-conical": FlaskConical,
  briefcase: Briefcase,
  wallet: Wallet,
  headphones: Headphones,
  smartphone: Smartphone,
  layers: Layers,
  workflow: Workflow,
  webhook: Webhook,
  telescope: Telescope,
  feather: Feather,
  gem: Gem,
  ghost: Ghost,
  coffee: Coffee,
  lightbulb: Lightbulb,
  laptop: Laptop,
};

/** Core's `AVATAR_COLORS`; each is a `--avatar-<key>` token in `index.css`. */
export const AVATAR_COLORS = [
  "violet", "indigo", "blue", "cyan", "teal", "green", "lime", "amber", "orange", "rose", "pink", "slate",
] as const;

export const avatarColorVar = (key: string | null | undefined): string | undefined =>
  key && (AVATAR_COLORS as readonly string[]).includes(key) ? `var(--avatar-${key})` : undefined;

/** The props `Avatar` takes for a user: an agent's icon, or a person's initials. */
export const avatarOf = (user: { displayName: string; icon?: string | null; iconColor?: string | null }) => ({
  name: user.displayName,
  icon: user.icon ?? null,
  iconColor: user.iconColor ?? null,
});
